import React from 'react';
import { Sparkles } from 'lucide-react';

/**
 * Badge "🆕 Nouveau" affiché pendant 7 jours après l'ajout d'un item ou d'une catégorie.
 * Props:
 *   - addedAt: ISO timestamp (string) ou null/undefined
 *   - days: nombre de jours d'affichage (défaut 7)
 */
export const NewItemBadge = ({ addedAt, days = 7, className = '' }) => {
  if (!addedAt) return null;
  let ts;
  try {
    ts = new Date(addedAt).getTime();
    if (Number.isNaN(ts)) return null;
  } catch {
    return null;
  }
  const ageMs = Date.now() - ts;
  if (ageMs > days * 24 * 60 * 60 * 1000 || ageMs < -60_000) return null;

  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[9px] font-bold uppercase tracking-wider bg-amber-500/20 text-amber-300 border border-amber-500/40 ${className}`}
      title={`Ajouté le ${new Date(addedAt).toLocaleDateString('fr-FR')}`}
      data-testid="new-item-badge"
    >
      <Sparkles className="w-2.5 h-2.5" />
      Nouveau
    </span>
  );
};

export default NewItemBadge;
